/* Native Shopify product forms; variants are resolved server-side, prices never fabricated. */
(() => {
  'use strict';
  if (window.galerieCoffretsLoaded) return;
  window.galerieCoffretsLoaded = true;
  const update = (radio, updateURL) => {
    const root = radio.closest('[data-coffret-section]');
    if (!root) return;
    root.querySelectorAll('[data-coffret-image]').forEach(image => { image.hidden = image.dataset.coffretImage !== radio.value; });
    const price = root.querySelector('[data-coffret-price]');
    const input = root.querySelector('[data-coffret-variant]');
    const button = root.querySelector('[data-coffret-add]');
    if (price) price.textContent = radio.dataset.price || '';
    if (input) input.value = radio.dataset.variantId || '';
    if (button) {
      const available = radio.dataset.available === 'true' && !!radio.dataset.variantId;
      button.disabled = !available;
      button.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
    }
    if (updateURL && !window.Shopify?.designMode) {
      const url = new URL(location.href);
      url.searchParams.set('format', radio.value);
      if (radio.dataset.variantId) url.searchParams.set('variant', radio.dataset.variantId);
      else url.searchParams.delete('variant');
      history.replaceState({}, '', url);
    }
  };
  const initialise = scope => {
    const roots = [...scope.querySelectorAll('[data-coffret-section]')];
    if (scope.matches?.('[data-coffret-section]')) roots.unshift(scope);
    roots.forEach(root => {
      const params = new URL(location.href).searchParams;
      const radios = [...root.querySelectorAll('[data-coffret-format]')];
      let selected = radios.find(r => params.get('variant') && r.dataset.variantId === params.get('variant'));
      if (!selected) selected = radios.find(r => r.value === params.get('format'));
      selected ||= radios.find(r => r.checked) || radios[0];
      if (selected) { selected.checked = true; update(selected, false); }
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-coffret-format]')) update(event.target, true);
  });
  document.addEventListener('submit', event => {
    const root = event.target.closest('[data-coffret-section]');
    if (!root) return;
    const button = root.querySelector('[data-coffret-add]');
    if (!root.querySelector('[data-coffret-variant]')?.value || button?.disabled) event.preventDefault();
  });
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  window.addEventListener('popstate', () => initialise(document));
})();
